import { render, staticRenderFns } from "./deprecation-modal.vue?vue&type=template&id=36f8c198&scoped=true"
import script from "./deprecation-modal.vue?vue&type=script&lang=js"
export * from "./deprecation-modal.vue?vue&type=script&lang=js"
import style0 from "./deprecation-modal.vue?vue&type=style&index=0&id=36f8c198&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8c198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f8c198')) {
      api.createRecord('36f8c198', component.options)
    } else {
      api.reload('36f8c198', component.options)
    }
    module.hot.accept("./deprecation-modal.vue?vue&type=template&id=36f8c198&scoped=true", function () {
      api.rerender('36f8c198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/deprecation-modal.vue"
export default component.exports